import { render, staticRenderFns } from "./qyzpxx.vue?vue&type=template&id=39a24a70&scoped=true"
import script from "./qyzpxx.vue?vue&type=script&lang=js"
export * from "./qyzpxx.vue?vue&type=script&lang=js"
import style0 from "./qyzpxx.vue?vue&type=style&index=0&id=39a24a70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a24a70",
  null
  
)

export default component.exports